<template>
	<!-- 员工端， 经理端 客户帮忙推荐, 信息录入页面 -->

  <bk-page class="customerleadsFormPage" pageType="navPage" :navBarInfo="navBarInfo">
    <bk-view class="view-container">
      <bk-view class="view-header-main">{{ politenessText }}</bk-view>
      <bk-view class="view-info-main">
        <bk-view class="view-form-main">
          <bk-view class="view-form-item">
            <bk-field-select v-if="regionList.length" type="choose" :dataList="regionList" langCode_label="customerleadsForm_country" v-model="formData.countryCode" />
          </bk-view>
          <bk-view class="view-form-item">
            <bk-input langCode_label="customerleadsForm_name" v-model:value="formData.customerName"></bk-input>
          </bk-view>
          <bk-view class="view-form-item">
						<bk-view class="view-label">
							<span class="view-must">*</span>
							<bk-lang code="customerleadsForm_phoneNumber"></bk-lang>
						</bk-view>
						<phoneInput
							:dataList="dictInfo.intMobileCd"
							v-model="formData.contactMobile"
							v-model:intMobileCd="formData.intMobileCd"
							v-model:intMobileCode="formData.intMobileCode"
						/>
          </bk-view>
          <bk-view class="view-form-item">
            <bk-input langCode_label="customerleadsForm_email" v-model:value="formData.contactMail"></bk-input>
          </bk-view>
        </bk-view>
        <bk-button langCode="customerleadsForm_submit" :loading="loadView==='save'" @click="handleSave"></bk-button>
      </bk-view>
    </bk-view>
		<bk-view class="view-bgImage"></bk-view>
  </bk-page>
</template>

<script>
	import phoneInput from '@/pages/login/signup/phoneInput/phoneInput.vue';
	import { shopReq, baseReq, authReq } from '@/reqService';

	export default {
		name:'customerleadsForm',
		components:{ phoneInput },
		data (){
			return {
				loadView:'',
				formData:{},
				dictInfo:{},
				regionList:[],
			};
		},
		computed:{
			navBarInfo (){
				return {
					backFlag: true, 
					titleAlign:'center',
					langCode_title: 'customerleadsForm_title'
				};
			},
			politenessText (){
				const { userName } = this.$route.query;
				let title = this.$bk_lang['customerleadsForm_politeness'];
				return title?.replace(/#VAR#/, userName);
			}
		},
		mounted (){
			window.setColorMain('#2E56F2');
			let token = this.$bk_getAccessToken();

			if (this.$bk_isNull(token)) {
				let that = this;
				window.viewCallback = function () {
					that.initData();
				};
				return;
			}
			this.initData();
		},
		beforeUnmount (){
			window.setColorMain();
		},
		methods:{
			async initData (){
				const { language } = this.$route.query;

				if (language !== this.$bk_getLanguageType()) {
					if (this.$bk_getUserInfo()) {
						await authReq.requestPostSwitchUserLanguage(this, {language }).catch(() => {});
					}

					let langItem = this.$bk_findObjInList(this.$bk_Global.languageTypeList, 'key', language);

					if(!langItem?.key){
						return false;
					}

					this.$store.commit('setItemState', { 'isSwitchLanguage': true });
				
					this.$bk_switchLang(language);

					location.reload();
				}

				this.requestGetRegionList();
				this.requestPostDictByTypeCode();
			},
			async requestGetRegionList (){
				const res= await baseReq.requestGetRegionList(this);
				this.regionList = res || [];
			},
			async requestPostDictByTypeCode (){
				const { compId } = this.$route.query;

				const resDict = await baseReq.requestPostDictByTypeCode(this, ['intMobileCd']);

				if(compId){
					const resShop = await shopReq.requestGetShopDetailByCompId(this, compId);
					this.formData.intMobileCode = resShop.countryCode?.toUpperCase() || 'CN';
					this.formData.intMobileCd = resDict.intMobileCd.find((v) => {
						return v.code === this.formData.intMobileCode; 
					})?.value;

				}

				this.dictInfo = resDict;
			},
			// 验证
			validate (){
				const { contactMobile, intMobileCode } = this.formData;

				let message = '';

				if(this.$bk_isNull(contactMobile)){
					message = 'customerleadsForm_msg_pleaseEnterPhoneNumber';
				}else if(this.$bk_isNull(intMobileCode)){
					message = 'customerleadsForm_msg_pleaseSelectAreaCode';
				}

				if(message){
					this.$bk_message.error({ langCode: message });
					return false;
				}

				return true;
			},
			getSubmitParams (){
				const { accountId } = this.$route.query;
				let params = { ...this.formData, accountId };

				params.countryName = this.$bk_findItem(this.regionList, params.countryCode).label;

				return params;
			},
			handleSave (){

				if(!this.validate()){
					return false;
				}

				this.loadView = 'save';
      
				shopReq.requestPostInviteRecordSave(this, this.getSubmitParams()).then(() => {
					this.loadView = '';
					this.$bk_message.success({langCode:'customerleadsForm_msg_addedSuccessfully'});
            
				}).catch(() => {
					this.loadView = '';
				});
			}
		}
	};
</script>

<style lang="less">
@import './customerleadsForm.less';
</style>